import { TrackingInterval } from '@/features/projects/create-subproject/types/tracking-interval';
import { supabase } from '@/lib/supabase';

export const updateTrackingInterval = async ({
  projectId,
  interval,
}: {
  projectId: number;
  interval: TrackingInterval;
}) => {
  const { error } = await supabase
    .from('projects')
    .update({ tracking_interval: interval })
    .eq('id', projectId);
  if (error) throw error;
};
